import { render, staticRenderFns } from "./OrangePickup.vue?vue&type=template&id=2efb3b7b&scoped=true&"
import script from "./OrangePickup.vue?vue&type=script&lang=js&"
export * from "./OrangePickup.vue?vue&type=script&lang=js&"
import style0 from "./OrangePickup.vue?vue&type=style&index=0&id=2efb3b7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efb3b7b",
  null
  
)

export default component.exports